import Vue from "vue";
import Router from "vue-router";
import Cookie from "js-cookie";
import { Capacitor } from "@capacitor/core";

Vue.use(Router);

// APP（Capacitor 原生壳）默认入口 = 数据看板；网页端仍进官网首页
export function defaultEntry() {
  return Capacitor.isNativePlatform() ? "/sort" : "/main";
}

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/main",
      name: "main",
      component: () => import("@/views/Main.vue"),
      meta: {
        keepAlive: true,
        isBack: false,
      },
    },
    {
      path: "/website",
      name: "website",
      component: () => import("@/views/Website.vue"),
    },
    {
      path: "/showroom",
      name: "showroom",
      component: () => import("@/views/Showroom.vue"),
      meta: {
        keepAlive: true,
        isBack: false,
      },
    },
    {
      path: "/location",
      name: "location",
      component: () => import("@/views/Location.vue"),
    },
    {
      path: "/card",
      name: "card",
      component: () => import("@/views/Card.vue"),
    },
    {
      path: "/search",
      name: "search",
      component: () => import("@/views/Search.vue"),
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/system/Home.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/waitShip",
      name: "waitShip",
      component: () => import("@/system/WaitShip.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/sort",
      name: "sort",
      component: () => import("@/system/Sort.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/patch",
      name: "patch",
      component: () => import("@/system/Patch.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login"),
    },
    {
      path: "/sol",
      name: "sol",
      component: () => import("@/views/SolanaWalletGenerator.vue"),
    },
    {
      path: "/eth",
      name: "eth",
      component: () => import("@/views/ETH.vue"),
    },
    {
      path: "/detail/:id",
      name: "detail",
      component: () => import("@/views/Detail.vue"),
    },
    {
      path: "/ship",
      name: "ship",
      component: () => import("@/views/Ship.vue"),
    },
    {
      path: "*", // 此处需特别注意置于最底部
      redirect: () => defaultEntry(),
    },
  ],
});

// 内部数据页需登录：未登录跳登录页，并带回跳地址
router.beforeEach((to, from, next) => {
  const needAuth = to.matched.some((r) => r.meta && r.meta.requiresAuth);
  if (needAuth && !Cookie.get("token")) {
    next({ path: "/login", query: { redirect: to.fullPath } });
    return;
  }
  next();
});

export default router;
